import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/support/page.tsx");
